import { Typography } from "antd";
import PropTypes from "prop-types";

const { Text } = Typography;

const SelectedItemDisplay = ({ itemCode, itemName, secondaryName }) => {
  return (
    <div>
      <Text>
        {itemCode} - {itemName}
      </Text>
      {secondaryName && (
        <div style={{ fontSize: 12, color: "#888", lineHeight: 1.3 }}>
          {secondaryName}
        </div>
      )}
    </div>
  );
};

SelectedItemDisplay.propTypes = {
  itemCode: PropTypes.string,
  itemName: PropTypes.string,
  secondaryName: PropTypes.string,
};

export default SelectedItemDisplay;
